import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skolahopar',
  templateUrl: './skolahopar.component.html',
  styleUrls: ['./skolahopar.component.css']
})
export class SkolahoparComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
